export default __webpack_public_path__ + "static/media/jolt-65-1.b4d392b5.jpg";